import React from 'react'
import Link from 'gatsby-link'

const ReserveMenu = ({ lang }) => {
  if (lang === 'es') {
    return (
      <ul className="dropdown locations_menu_reserve">
        <li>
          <Link to="/reserve">Hacer una Reserva</Link>
        </li>
        <li>
          <Link to="/reserve">Modificar</Link>
        </li>
        <li>
          <Link to="/reserve">Cancelar</Link>
        </li>
        
      </ul>
    )
  }
  return (
    <ul className="dropdown locations_menu_reserve">
      <li>
        <Link to="/reserve">Make a Reservation</Link>
      </li>
      <li>
        <Link to="/reserve">Modify</Link>
      </li>
      <li>
        <Link to="/reserve">Cancel</Link>
      </li>
      
    </ul>
  )
}

export default ReserveMenu



// WEBPACK FOOTER //
// ./src/menus/ReserveMenu.js